<template>
  <v-dialog
    v-if="selected"
    :value="dialog"
    :hide-overlay="!dialog"
    @click:outside.stop="closeDialog(true)"
    @keydown.esc="closeDialog(true)"
    persistent
    max-width="700px"
    :fullscreen="is_mobile"
    :scrollable="is_mobile"
    overlay-opacity="50"
    overlay-color="#ffffff"
    content-class="default-dialog"
    >
    <v-card class="default-dialog-card">
      <v-card-title class="dialog-title">
        <span class="headline">
          <v-icon class="toolbar-icon">{{ (id > 0 ? 'mdi-playlist-edit' : 'mdi-playlist-plus') }}</v-icon>
          {{ (id > 0 ? `${lang.items.edit.title} #${id}` : lang.items.new.title) }}
        </span>
        <v-spacer></v-spacer>
        <v-icon class="dialog-close-btn" @click="closeDialog(true)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-2">
        <Stock
          :value="selected"
          :dialog="stockDialog"
          :qty="newStock"
          @closed="closedStock"
          :key="newStock"
        />
        <v-container class="px-0">
          <v-form
            ref="SaveForm"
            v-model="valid"
            lazy-validation
            :disabled="get_interface.loading"
            class="items-form"
          >
            <v-row>
              <v-col cols="4" lg="3" md="3" sm="4" class="pa-0">
                <Thumb
                  :photo="selected.photo"
                  :size="154"
                  :edit="true"
                  @changed="imageChanged"
                />
              </v-col>
              <v-col cols="8" lg="9" md="9" sm="8" class="pa-0">
                <v-row class="items-form-row">
                  <v-col cols="3">
                    <v-text-field
                      :label="lang.items.datatable.headers.code"
                      v-model="code"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="9">
                    <v-text-field
                      :label="lang.items.datatable.headers.title"
                      v-model="selected.title"
                      :rules="lang.items.new.rules.titleRules"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      autocomplete="new-password"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="items-form-row">
                  <v-col cols="7">
                    <treeselect
                      :options="categories"
                      v-model="selected.cat"
                      :placeholder="lang.items.new.category"
                      :noChildrenText="lang.items.new.noChildrenText"
                      :noOptionsText="lang.items.new.noCategoriesText"
                      :noResultsText="lang.items.new.noResultsText"
                      :clearable="false"
                      :default-expand-level="1"
                      :required="true"
                    />
                  </v-col>
                  <v-col cols="4">
                    <v-currency-field
                      :label="lang.items.datatable.headers.price"
                      v-model="selected.price"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      filled
                    ></v-currency-field>
                  </v-col>
                  <v-col cols="1">
                    <v-switch
                      v-model="selected.active"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      class="active-switch"
                      inset
                    ></v-switch>
                  </v-col>
                </v-row>
                <v-row class="items-form-row" style="max-height: unset !important; margin-bottom: 15px !important;">
                  <v-col cols="12">
                    <v-textarea
                      :label="lang.items.datatable.headers.description"
                      v-model="selected.description"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      filled
                      auto-grow
                      clearable
                      clear-icon="mdi-broom"
                      counter="470"
                      :rows="7"
                      class="description-field"
                      hide-details
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row
                  v-if="permissions.catalog.stock"
                  class="items-form-row"
                >
                  <v-col cols="7">
                    <v-select
                      v-model="selected.stock"
                      :items="get_global.defaults.options.catalog.items.stock"
                      :label="lang.items.datatable.headers.stock"
                      :loading="get_interface.loading"
                      :disabled="get_interface.loading"
                      prepend-inner-icon="mdi-package-variant-closed"
                      item-text="title"
                      item-value="id"
                      attach
                      filled
                      dense
                      hide-details
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="selected.qty"
                      :label="lang.items.datatable.headers.qty"
                      :loading="get_interface.loading"
                      :disabled="(selected.stock === 0) || get_interface.loading"
                      type="number"
                      clear-icon="mdi-broom"
                      filled
                      hide-details
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="gray" text @click="closeDialog(true)">{{ lang.items.view.close }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save_(selected)"
          :loading="get_interface.loading"
          :disabled="get_interface.loading"
        >
          {{ lang.items.actions.save }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Thumb from '@/components/catalog/items/templates/Thumb'
import Stock from './templates/Stock'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import appdata from '@/mixins/appdata'
import save from '@/mixins/defaults/save'
import utils from '@/mixins/utils'
import catalog from '../mixins/index'

export default {
  components: { Thumb, Treeselect, Stock },
  mixins: [ appdata, save, utils, catalog ],
  data: () => ({
    valid: false,
    stockDialog: false
  }),
  computed: {
    categories: function () {
      const noCategory = [
        {
          id: 0,
          name: this.lang.categories.new.no_cat,
          parent: 0
        }
      ]
      var itemsCat = Object.values(this.get_data.categories) || []
      itemsCat = itemsCat.filter(cat => cat.catalog === 'items') || []
      itemsCat = noCategory.concat(itemsCat)
      var parents = itemsCat.filter(parent => parent.parent === 0) || []
      parents.forEach(function (val) {
        const childrens = itemsCat.filter(children => children.parent !== 0 && children.parent === val.id) || []
        childrens.forEach(function (childVal) {
          childVal.label = childVal.name
        })
        val.label = val.name
        val.children = (childrens.length > 0 ? childrens : [])
      })
      return parents
    },
    code: {
      get () {
        return (typeof this.selected !== 'undefined' && typeof this.selected.cod !== 'undefined' ? this.selected.cod.toString().trim() : '')
      },
      set (val) {
        if (val) {
          this.selected.cod = val.trim()
        }
      }
    },
    newStock () {
      this.value
      this.selected
      return parseInt(parseInt(this.selected.qty) - parseInt(this.value.qty))
    }
  },
  methods: {
    imageChanged (image) {
      this.selected.photo = image
    },
    closedStock (val) {
      this.stockDialog = !val
    }
  }
}
</script>

<style scoped src="./styles/save.scss" lang="scss"></style>
